
import { MapTo } from '@adobe/aem-react-editable-components';
import ReviewsTricardModule, { ReviewsTricardModuleEditConfig } from './ReviewsTricardModule';

export default MapTo('cob-corp-acquisition/components/creditonebank/reviews-tricard-module')(ReviewsTricardModule, ReviewsTricardModuleEditConfig);
        